import React from "react"
import styled from "styled-components"
import { Card, CardBody } from "reactstrap"

const CohortReportsChartView = props => {
  return (
    <CohortReportsChartViewStyled>
      <CardBody>
        Chart
      </CardBody>
    </CohortReportsChartViewStyled>
  )
}

CohortReportsChartView.propTypes = {}

const CohortReportsChartViewStyled = styled(Card)`
`

export default (CohortReportsChartView)
